import { cn } from '../../lib/cn'

type SkeletonProps = {
  className?: string
  /**
   * Screen readers should hear the loading state once, from the region that
   * owns it — not from every individual bar. Default is decorative.
   */
  label?: string
}

/**
 * Loading placeholder. The shimmer runs at the 1200 ms linear loop the motion
 * tokens specify and is switched off under `prefers-reduced-motion`.
 */
export const Skeleton = ({ className, label }: SkeletonProps) => (
  <span
    className={cn('skeleton block rounded-md', className)}
    role={label ? 'status' : undefined}
    aria-hidden={label ? undefined : true}
  >
    {label ? <span className="sr-only">{label}</span> : null}
  </span>
)
